


import React from "react";

const Icon4: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="28"
      fill="transparent"
      viewBox="0 0 30 28"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 10.773h5.333"
      ></path>
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M26.777 12.107h-3.469c-2.38 0-4.308 1.79-4.308 4s1.93 4 4.307 4h3.47c.112 0 .167 0 .214-.003.72-.044 1.293-.576 1.34-1.244.002-.042.002-.094.002-.197V13.55c0-.103 0-.155-.002-.197-.048-.668-.62-1.2-1.34-1.244-.047-.003-.102-.003-.214-.003z"
      ></path>
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M26.954 12.107c-.104-2.496-.438-4.027-1.516-5.104-1.562-1.563-4.076-1.563-9.104-1.563h-4c-5.028 0-7.543 0-9.104 1.563-1.563 1.561-1.563 4.076-1.563 9.104s0 7.543 1.563 9.104c1.561 1.563 4.076 1.563 9.104 1.563h4c5.028 0 7.542 0 9.104-1.563 1.078-1.077 1.413-2.608 1.516-5.104"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2"
        d="M7 5.44l4.98-3.303a4.316 4.316 0 014.707 0l4.98 3.303"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.667"
        d="M22.988 16.107h.014"
      ></path>
    </svg>
  );
}

export default Icon4;
